(function () {
  if (window.dsSearchSidebarLoaded) return;
  window.dsSearchSidebarLoaded = true;

  // Helper: Debounce function to limit API calls
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    const searchInputs = document.querySelectorAll(".ds-header-search__input");
    // Check if we are on the search page (main results container exists)
    const mainResultsContainer = document.querySelector("main .ds-search") || document.querySelector(".ds-search");
    
    const overlay = document.getElementById("ds-search-results-overlay");
    const overlayInner = overlay ? overlay.querySelector(".ds-search-results-inner") : null;

    // We need either a main results container or an overlay to function
    if (!mainResultsContainer && !overlay) return;

    const performSearch = async (query) => {
      if (!query.trim()) {
        if (overlay) overlay.classList.add("hidden");
        return;
      }

      // Construct the search URL correctly, preserving locale
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const searchPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.search_url) || (root + (root.endsWith('/') ? 'search' : '/search'));
      
      const url = new URL(searchPath, window.location.origin);
      url.searchParams.set("q", query);
      
      // Only update URL history if we are already on the search page
      if (mainResultsContainer) {
        window.history.pushState({}, "", url);
      }

      try {
        // Fetch the search page HTML for the new query
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error("Network response was not ok");
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        
        const newContent = doc.querySelector(".ds-search");
        
        if (newContent) {
          if (mainResultsContainer) {
            // Scenario A: We are already on the search page, update in place
            mainResultsContainer.innerHTML = newContent.innerHTML;
          } else if (overlay && overlayInner) {
            // Scenario B: We are on a different page, use overlay
            overlayInner.innerHTML = newContent.innerHTML;
            overlay.classList.remove("hidden");
          }
          
          // Update document title if available
          if (doc.title && mainResultsContainer) {
            document.title = doc.title;
          }
        }
      } catch (error) {
        console.error("Live search failed:", error);
      }
    };

    const onSearchInput = debounce((e) => {
      const query = e.target.value;
      performSearch(query);
    }, 300);

    searchInputs.forEach((input) => {
      // Listen for typing
      input.addEventListener("input", onSearchInput);

      // Re-open overlay on focus if we have content
      input.addEventListener("focus", () => {
        if (overlay && overlayInner && overlayInner.innerHTML.trim() !== "" && input.value.trim() !== "") {
          overlay.classList.remove("hidden");
        }
      });

      // Prevent default form submission (page reload) on Enter
      const form = input.closest("form");
      if (form) {
        form.addEventListener("submit", (e) => {
          // If on search page, prevent reload and just search
          if (mainResultsContainer) {
            e.preventDefault();
            performSearch(input.value);
          }
          // If on overlay, let it submit naturally to go to full search page
        });
      }
    });

    // Close overlay on click outside or Escape
    document.addEventListener("click", (e) => {
      if (overlay && !overlay.classList.contains("hidden")) {
        // If click is outside overlay AND outside any search input
        const clickedInput = Array.from(searchInputs).some(i => i.contains(e.target));
        if (!overlay.contains(e.target) && !clickedInput) {
          overlay.classList.add("hidden");
        }
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && overlay && !overlay.classList.contains("hidden")) {
        overlay.classList.add("hidden");
      }
    });
  });
})();
